import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-brand-light px-4 py-6 sm:px-6" aria-labelledby="guarantee-heading" data-id="element-71" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl rounded-2xl border border-brand-gold/60 bg-white p-4 text-center shadow-sm" data-id="element-72" data-mp="223685s65k1rq">
        <p className="mb-1 font-heading text-[10px] font-semibold uppercase tracking-widest text-brand-muted" data-id="element-73" data-mp="1x422hbifsm65">
          Your Investment Is 100% Protected
        </p>
        <div className="mx-auto mb-1 flex h-11 w-11 items-center justify-center rounded-full bg-brand-red/10" data-id="element-74" data-mp="14fo2iq7sffry">
          <ShieldCheckIcon className="h-6 w-6 text-brand-red" aria-hidden="true" data-id="element-75" data-mp="1j4ahgqti65in" />
        </div>
        <h2 id="guarantee-heading" className="mb-1 text-xl leading-none text-brand-ink sm:text-2xl" data-id="element-76" data-mp="1ee3uswijwv31">
          🛡️ 7-DAY MONEY-BACK GUARANTEE
        </h2>
        <p className="text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-77" data-mp="qmokaggmf7gp">
          Explore the complete system for seven full days. Review every module. Use the sessions
          with your athletes. Apply the drills. Organize your coaching. Experience how much time this
          system can save every single week. If you're not completely satisfied, simply contact us
          within the first 7 days and we'll refund 100% of your purchase. No questions asked.
        </p>
      </div>
    </section>;
}